/* global Sys, Core, Services */
Sys.ns("Core");

/**
 * The Play For Real Promo controller.
 *
 * @class Core.PlayForRealPromoController
 * @extends Core.Controller
 */
Core.PlayForRealPromoController = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.PlayForRealPromoController.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupEvents: function() {
        var me = this;

        me.on({
            "notify:stateHandler.enteringIdleState": me.onEnteringIdleState,
            "request:playForRealPromo:enable": me.onEnable,
            "request:playForRealPromo:disable": me.onDisable
        });
    },

    /**
     * On idle state, check if play for real promo is defined and how many rounds are left.
     * If zero, show dialog.
     *
     * @returns {void}
     */
    onEnteringIdleState: function() {
        var me = this,
            roundsLeft = me.model.readData("roundsLeft");

        if (roundsLeft === 0 && !me.isDisabled) {
            me.requestDialog();
        }
        else {
            me.complete();
        }

        if (Sys.isDefined(roundsLeft)) {
            me.model.handleRounds();
        }
    },

    /**
     * Request a dialog from the dialog manager.
     *
     * @returns {void}
     */
    requestDialog: function() {
        Services.dialog.show(this.model.getDialog(this));
    },

    /**
     * Fire event when play for real promo sequence has been completed.
     *
     * @returns {void}
     */
    complete: function() {
        this.fireEvent("notify:playForRealPromo:completed");
    },

    /**
     * Enable play for real promo.
     *
     * @returns {void}
     */
    onEnable: function() {
        this.isDisabled = false;
    },

    /**
     * Disable play for real promo.
     *
     * @returns {void}
     */
    onDisable: function() {
        this.isDisabled = true;
    }
};

Core.PlayForRealPromoController = Sys.extend(Core.Controller, Core.PlayForRealPromoController, "Core.PlayForRealPromoController");
